module.exports = __webpack_public_path__ + "img/item-1.6cdba98.png";